import axios from "axios";
import { STORAGE_CONSTANTS } from "../../shared/Constants/Constants";
import { base_url, miscellaneous_api } from "../ApiConst";
import { axiosInstance } from "../axios";

export const Languages = async () => {
  // Uses static Token
  try {
    return await axiosInstance.get(miscellaneous_api.languages(), {
      useUserToken: false,
    });
  } catch (error) {
    throw error;
  }
};

export const All_Subcategories = async () => {
  try {
    const response = await axiosInstance.get(
      miscellaneous_api.all_subcategories(),
      { useUserToken: false }
    );
    return response;
  } catch (error) {
    throw new Error(error);
  }
};
export const subcategories = async () => {
  try {
    const response = await axiosInstance.get(
      miscellaneous_api.subcategories(),
      { useUserToken: false }
    );
    return response;
  } catch (error) {
    throw new Error(error);
  }
};
export const Payment_Status = async (uuid) => {
  try {
    let userToken1 = localStorage.getItem(STORAGE_CONSTANTS.USER_TOKEN);
    let enc_code = window.location.href;
    const data = enc_code.split("data=")[enc_code.split("data=").length - 1];
    let success = true ? enc_code.includes("confirm-order") : false;
    let check_url = success
      ? `${base_url}payments/check_payment/esewa/${
          uuid.split("uuid=")[1].split("&")[0]
        }/`
      : `${base_url}payments/check_payment/esewa/${
          uuid.split("uuid=")[1].split("&")[0]
        }/?data=${data}`;
    return await axios.get(check_url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${userToken1}`,
      },
    });
  } catch (error) {
    throw error;
  }
};
export const getDetailedLocationWithLatandLong = async (
  latitude,
  longitude,
  apiKey
) => {
  try {
    return await axios.get(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`
    );
  } catch (error) {
    throw error;
  }
};
